module.exports = __webpack_public_path__ + "img/qr_chadle_w.5ea3f10b.svg";